import React from "react";

const Assign = () => {
  return (
    <div>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0003 7.42453C10.0003 8.74523 8.92991 9.81586 7.60952 9.81586C6.28913 9.81586 5.21875 8.74523 5.21875 7.42453C5.21875 6.10384 6.28913 5.0332 7.60952 5.0332C8.92991 5.0332 10.0003 6.10384 10.0003 7.42453Z"
          stroke="#8796AF"
          stroke-width="1.67"
        />
        <path
          d="M10.7755 15.9656H4.43263C3.73202 15.9656 3.16406 15.4412 3.16406 14.7944C3.16406 13.1772 4.58396 11.8662 6.33549 11.8662H8.87261C9.58656 11.8662 10.2455 12.084 10.7755 12.4516"
          stroke="#8796AF"
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7875 11.8662V15.9656M16.8367 13.9159H12.7383"
          stroke="#8796AF"
          stroke-width="1.67"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default Assign;
